const encodeId = (id: string): string => {
  return encodeURIComponent(id);
};

export { encodeId };
